'use client';
import { Fragment } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { CommentItemWithAction } from '~/app/(default-layout)/s/[storyId]/_components/comment-item-with-action';
import type { UserOverview } from '~/common/types/user-overview';
import { Color } from '~/utils/styles/enums';
import { Loading } from '@app/_components/loading';
import { Divider, HStack, Paragraph, VStack } from '@styled-system/jsx';
import { useLocalState } from './use-local-state';

export type CommentsDetailContainerProps = {
  storyId: string;
  author: UserOverview | undefined;
  parentCommentId: string;
};

export const ReplyCommentsDetailContainer = ({
  storyId,
  author,
  parentCommentId,
}: CommentsDetailContainerProps) => {
  const {
    tellerUser,
    comments,
    isLoading,
    hasNext,
    handleLoadMore,
    handleOnClickLike,
    handleOnDelete,
  } = useLocalState({
    storyId,
    parentCommentId,
  });

  return (
    <VStack w="100%" bg="white" alignItems="flex-start">
      {comments.map((comment, index) => {
        const isLast = comments.length - 1 === index;
        return (
          <Fragment key={comment.id}>
            <CommentItemWithAction
              storyId={storyId}
              comment={comment}
              author={author}
              isOwner={comment.user.id === tellerUser?.id}
              disableReply={true}
              onClickLike={handleOnClickLike}
              onClickDelete={handleOnDelete}
              animationName="fade-in"
              animationDuration="0.2s"
            />

            {!isLast && <Divider />}
          </Fragment>
        );
      })}

      {hasNext && (
        <HStack gap="1" mt="3" cursor="pointer" onClick={handleLoadMore}>
          <IoIosArrowDown color={Color.TINT} />
          <Paragraph fontSize="size_14" color="content_link_primary">
            もっと見る
          </Paragraph>
        </HStack>
      )}

      {isLoading && <Loading />}
    </VStack>
  );
};
